<div role="group" class="nimbus-date-range-input-container" [formGroup]="form" (focusin)="onFocusIn()" (focusout)="onFocusOut($event)">
  @for (datePart of dateParts; track datePart; let last = $last; let first = $first; let index = $index) {
    @if (first) {
      <input
        #datePartInput
        nimbusMatTimeNumber
        [maxValue]="datePart.maxValue"
        [lengthLimit]="datePart.maxLength"
        [id]="datePart.type"
        [class]="datePart.type"
        [formControlName]="datePart.type"
        [maxlength]="datePart.maxLength"
        (blur)="onBlur(form.controls[datePart.type], datePart.maxLength)"
        (input)="handleInput(form.controls[datePart.type], index + 1, datePart.maxLength)"
        (focus)="onFocus(index)"
        (keyup.arrowRight)="autoFocusNext(form.controls[datePart.type], index + 1, datePart.maxLength)"
      />
    }
    @if (!first && !last) {
      <input
        #datePartInput
        nimbusMatTimeNumber
        [maxValue]="datePart.maxValue"
        [lengthLimit]="datePart.maxLength"
        [id]="datePart.type"
        [class]="datePart.type"
        [formControlName]="datePart.type"
        [maxlength]="datePart.maxLength"
        (blur)="onBlur(form.controls[datePart.type], datePart.maxLength)"
        (input)="handleInput(form.controls[datePart.type], index + 1, datePart.maxLength)"
        (focus)="onFocus(index)"
        (keyup.backspace)="autoFocusPrev(form.controls[datePart.type], index - 1)"
        (keyup.arrowLeft)="autoFocusPrev(form.controls[datePart.type], index - 1, true)"
        (keyup.arrowRight)="autoFocusNext(form.controls[datePart.type], index + 1, datePart.maxLength)"
      />
    }
    @if (last) {
      <input
        #datePartInput
        nimbusMatTimeNumber
        [maxValue]="datePart.maxValue"
        [lengthLimit]="datePart.maxLength"
        [id]="datePart.type"
        [class]="datePart.type"
        [formControlName]="datePart.type"
        [maxlength]="datePart.maxLength"
        (blur)="onBlur(form.controls[datePart.type], datePart.maxLength)"
        (input)="handleInput(form.controls[datePart.type])"
        (focus)="onFocus(index)"
        (keyup.backspace)="autoFocusPrev(form.controls[datePart.type], index - 1)"
        (keyup.arrowLeft)="autoFocusPrev(form.controls[datePart.type], index - 1, true)"
      />
    }
    @if (!last && form.controls[datePart.type]?.value?.length) {
      <span>{{ separator }}</span>
    }
  }
</div>
